import React, { FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

interface CertificateDialog {
  open: boolean;
  onClose: () => void;
  title: string;
  text: React.ReactFragment;
}

const CertificateDialog: FC<CertificateDialog> = ({ onClose, open, title, text }) => {

  return (
    <Dialog
        open={open}
        //onClose={handleClose}
        aria-labelledby="certificate-dialog-title"
        aria-describedby="certificate-dialog-description"
      >
        <DialogTitle id="certificate-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="certificate-dialog-description">
                {text}
          </DialogContentText>   
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" autoFocus>
            Luk
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default CertificateDialog;